module.exports = __webpack_public_path__ + "static/online-shop-2-a6f06807aa3f1af59c42b1ff8ae1e367.png";